import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import VeeValidate, { Validator } from 'vee-validate'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import es from 'vee-validate/dist/locale/es'
import vSelect from 'vue-select'

Vue.config.productionTip = false
Vue.component('v-date-picker', DatePicker)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(VeeValidate, {
  errorBagName: 'vverrors',
  fieldsBagName: 'vvfields',
  events: 'change|blur'
})

Validator.localize('es', es)
Vue.component('v-select', vSelect)
